<script>
import FormGroup from '@maison/components/form/FormGroup.vue';
import CheckboxField from '@maison/components/form/fields/CheckboxField.vue';
import ConsentBoxField from './fields/ConsentBoxField';
import KoreanGDPR from '@phoenix/mixins/components/form/KoreanGDPR';

export default {
  components: {
    FormGroup,
    CheckboxField,
    ConsentBoxField,
  },

  mixins: [KoreanGDPR],

  props: {
    customOuterClass: {
      type: String,
      default: null,
    },
  },

  computed: {
    outerClass() {
      return this.customOuterClass || 'container sgphx-mt-md';
    },
  },
};
</script>

<template>
  <div v-if="displayGDPR && currentForm" :class="outerClass">
    <consent-box-field
      v-for="(consentBox, index) in currentForm.consentBoxes"
      :key="consentBox.id"
      :consent-data="consentBox"
      @update="(value) => updateConsentBoxValue(index, value)"
      @update-marketing-consents="(value) => updateConsentBoxMarketingConsents(index, value)"
    />
    <p class="sgphx-mb-base sgphx-mt-0" v-html="currentForm.footer"></p>
    <form-group :show-label="false" :attrs="age" is-sgphx>
      <p class="sgphx-mb-0">{{ $t('Form.iAmOver14YearsOld.description') }}</p>
      <checkbox-field v-model="age.value" is-sgphx />
    </form-group>
  </div>
</template>
